import { render, staticRenderFns } from "./DomainActionForm.vue?vue&type=template&id=47290e8c&scoped=true&"
import script from "./DomainActionForm.vue?vue&type=script&lang=js&"
export * from "./DomainActionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47290e8c",
  null
  
)

export default component.exports